module.exports = __webpack_public_path__ + "img/unicredit-bold.5de1ab44.svg";